import { CommonModule } from "@angular/common";
import { Component, Input, OnChanges, Output, EventEmitter, SimpleChanges } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { MatCardModule } from "@angular/material/card";
import { MatChipsModule } from "@angular/material/chips";
import { MatIconModule } from "@angular/material/icon";
import { PolicyTrackerData } from "../policy-tracker.interfaces";
import { Status, StatusText, StatusClass } from "../policy-status.constants";

@Component({
  selector: "app-policy-tracker-header",
  standalone: true,
  imports: [CommonModule, MatCardModule, MatChipsModule, MatIconModule, FlexLayoutModule],
  templateUrl: "./policy-tracker-header.component.html",
  styleUrls: ["./policy-tracker-header.component.scss"],
})
export class PolicyTrackerHeaderComponent implements OnChanges {
  @Input() policy!: PolicyTrackerData;
  @Input() status!: string;
  @Output() statusChange = new EventEmitter<string>();

  public Status = Status;
  public statusText = "";
  public statusClass = "chip-default";

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["status"] && changes["status"].currentValue) {
      const statusValue = this.status.toUpperCase();
      this.statusText = StatusText[statusValue] ?? this.status;
      this.statusClass = StatusClass[statusValue] ?? "chip-default";
    }
  }
}
